/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { TriggerUser } from '@/commons/protocols';

export const formatDate = (date: Date | string, short?: boolean) => {
    let d: Date;
    if (typeof date === 'string') {
        d = new Date(date);
    } else {
        d = date;
    }
    const today = new Date();
    if (today.toDateString() === d.toDateString()) return 'Today at ' + d.toLocaleTimeString();
    return short ? d.toLocaleDateString() : d.toLocaleDateString() + ' at ' + d.toLocaleTimeString();
};

/*export const roundTo = (input: number, digits: number): string => {
    const rounder = Math.pow(10, digits);
    return (Math.round(input * rounder) / rounder).toFixed(digits);
};*/

export const displayUser = (user?: TriggerUser, withoutPrefix?: boolean): string => {
    let returnValue = 'CI';

    if (user) {
        if (user.isOperator) {
            returnValue = user.email;
        } else if (user.username) {
            returnValue = user.username;
        } else if (user.firstName) {
            returnValue = `${user.firstName} ${user.lastName}`;
        } else {
            returnValue = user.email;
        }
    }

    if (!returnValue) {
        returnValue = 'CI';
    }

    if (withoutPrefix) return returnValue;
    return `by ${returnValue}`;
};

export const cn = (...inputs: ClassValue[]) => {
    return twMerge(clsx(inputs));
};

export const parseIndex = (index: string | null) => {
    if (index === null) return undefined;
    const p = parseInt(index);
    if (isNaN(p)) return undefined;
    return p;
};
